
// requiring html templates so that hot reloading works
const template = require('./guestListItem.html');
const NS = 'GuestListItemComponent'; // jshint ignore:line

export default {
  bindings: {
    firstName: '=',
    lastName: '=',
    phoneNumber: '=',
    forceValidation: '=',
    isCompact: '<',
    siblingIndex: '<',
    onContentChanged: '&onContentChanged'
  },
  controllerAs: 'vm',
  template,
  controller
};

function controller($scope, $timeout, unregister) {
  "ngInject";

  const vm = this;
  let listeners;

  vm.$onInit = () => {

    listeners = [];

    vm.hasContentAndInvalid = false;

    listeners.push($scope.$watch('vm.firstName', formChanged));
    listeners.push($scope.$watch('vm.lastName', formChanged));

    // needs timeout because 'phone-vaild' directive changes the form outside of angular cycle
    listeners.push($scope.$watch('vm.phoneNumber', () => $timeout(formChanged, 0)));

    formChanged();
  };


  vm.$onDestroy = () => {
    unregister(listeners);
  };

  function formChanged() {
    // vm.phoneNumber will be null if text entered but is not valid, so we use undefined to check if it is empty
    var phoneIsEmpty = vm.phoneNumber === undefined || vm.phoneNumber === '';

    var hasContent = (!!vm.firstName || !!vm.lastName || !phoneIsEmpty);

    const isDirty = vm.formDetails && vm.formDetails.$dirty;
    const isInvalid = vm.formDetails && vm.formDetails.$invalid;
    const isValid = vm.formDetails && vm.formDetails.$valid;

    vm.hasContentAndInvalid = hasContent && (isDirty || vm.forceValidation) && isInvalid;

    vm.onContentChanged({isValid: !hasContent || isValid});
  }
}
